module.exports = __webpack_public_path__ + "img/25.25b7184e.jpg";